var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25Z",
    fill: "#0088CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6561 24.5442C19.367 21.6204 23.842 19.6928 26.081 18.7615C32.474 16.1025 33.8024 15.6406 34.6682 15.6251C34.8587 15.622 35.2845 15.6692 35.5603 15.893C35.7932 16.0819 35.8572 16.3372 35.8879 16.5164C35.9186 16.6955 35.9567 17.1037 35.9264 17.4226C35.5799 21.0626 34.0809 29.8961 33.3183 33.973C32.9956 35.6981 32.3602 36.2765 31.7451 36.3331C30.4082 36.4561 29.3931 35.4496 28.0983 34.6009C26.0723 33.2728 24.9276 32.446 22.961 31.15C20.6882 29.6523 22.1615 28.8291 23.4568 27.4837C23.7958 27.1317 29.6859 21.7742 29.7999 21.2881C29.8142 21.2274 29.8274 21.0008 29.6928 20.8812C29.5582 20.7615 29.3595 20.8024 29.2162 20.835C29.0129 20.8811 25.7763 23.0204 19.5061 27.253C18.5874 27.8838 17.7552 28.1912 17.0096 28.1751C16.1877 28.1573 14.6066 27.7104 13.4312 27.3283C11.9896 26.8597 10.8438 26.6119 10.9436 25.816C10.9955 25.4015 11.5664 24.9776 12.6561 24.5442Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.60785b235e1008bcdf487043047d74af.svg";
export { ForwardRef as ReactComponent };